import fetchJSON from '@api/api_helper';

const { type, key } = BF.fx.resource();
const url = () => `/api/v4/${type}s/${key}/labels?per=1000`;

export const get = () => (
  fetchJSON(url())
    .then(({ data }) => data)
    .catch(async (response) => { throw (await response.json()); })
);

export const create = (options) => (
  // example options: {name: 'Sales Team', position: 6, parent_key: 'abcd'}
  // omitted parent_key results in top level label
  // omitted position results in position 0
  fetchJSON(url(), {
    method: 'POST',
    body: {
      data: {
        attributes: {
          ...options
        }
      }
    }
  }).catch(async (response) => { throw (await response.json()); })
);


// helper: returns tree object of all labels with their attributes
export const formatLabelsTree = (labels) => {
  const labelsTree = {};

  labels.forEach((label) => {
    const { attributes } = label;
    const { path } = attributes;
    let current = labelsTree;

    path.forEach((currentId) => {
      if (!current[currentId]) {
        current[currentId] = {};
      }

      current = current[currentId];
    });
    current.attributes = attributes;
  });

  return labelsTree;
};

// helper: returns flat object of all labels with their attributes
export const formatLabelsFlat = (labels) => {
  const labelsFlat = {};

  labels.forEach((label) => { labelsFlat[label.id] = label.attributes; });

  return labelsFlat;
};
